import React, { useCallback, useRef, useState, ForwardedRef, useImperativeHandle } from 'react'
import { InputAdornment, TextField } from '@mui/material'
import { Search } from '@mui/icons-material'

type SearchbarProps = {
  placeholder: string
  handleChange: (value: string) => void
}

export interface SearchbarRef {
  reset: () => void
}

const Searchbar = React.forwardRef((props: SearchbarProps, ref: ForwardedRef<SearchbarRef>) => {
  const [input, setInput] = useState('')

  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      e.stopPropagation()
      const value = e.target.value
      setInput(value)
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      timeoutRef.current = setTimeout(() => {
        props.handleChange(value)
      }, 500)
    },
    [props]
  )

  const reset = () => {
    setInput('')
  }

  useImperativeHandle(ref, () => ({
    reset,
  }))

  return (
    <>
      <label htmlFor="search-bar" style={{ position: 'absolute', width: '1px', height: '1px', margin: '-1px', padding: 0, overflow: 'hidden', border: 0, clip: 'rect(0, 0, 0, 0)' }}>
        Search
      </label>
      <TextField
        id="search-bar"
        sx={{ height: 'fit-content' }}
        placeholder={props.placeholder}
        size="small"
        fullWidth
        value={input}
        onChange={handleInputChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search aria-hidden="true" />
            </InputAdornment>
          ),
        }}
      />
    </>
  )
})

export default Searchbar
